import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AddCluster.css';

function AddCluster() {
  const navigate = useNavigate();
  const { isSuperAdmin } = useAuth();

  useEffect(() => {
    if (!isSuperAdmin) navigate('/clusters');
  }, [isSuperAdmin, navigate]);

  return (
    <div className="add-cluster-container">
      <div className="page-header">
        <h1>Add Cluster</h1>
        <button className="button button-secondary" onClick={() => navigate('/clusters')}>
          Cancel
        </button>
      </div>

      <div className="cluster-type-selection">
        <p className="cluster-type-subtitle">
          How would you like to add a cluster?
        </p>

        <div className="cluster-type-cards">
          <div className="cluster-type-card" onClick={() => navigate('/clusters/provision')}>
            <div className="cluster-type-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <path d="M8 21h8M12 17v4" />
                <path d="M7 8h2M11 8h2M15 8h2M7 11h2M11 11h2M15 11h2" />
              </svg>
            </div>
            <h2>New Cluster</h2>
            <p>
              Add bare servers and let us handle everything — prerequisites,
              Kubernetes installation, networking, and configuration.
            </p>
            <ul className="cluster-type-features">
              <li>Automated K8s installation via kubeadm</li>
              <li>CNI, Ingress, Metrics Server setup</li>
              <li>Real-time provisioning progress</li>
              <li>Multi-node support</li>
            </ul>
            <button className="button button-primary cluster-type-btn">
              Provision New Cluster
            </button>
          </div>

          <div className="cluster-type-card" onClick={() => navigate('/clusters/import')}>
            <div className="cluster-type-icon cluster-type-icon-green">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            <h2>Import Existing Cluster</h2>
            <p>
              Already have a running Kubernetes cluster? Connect it by
              providing your kubeconfig. Works with any K8s distribution.
            </p>
            <ul className="cluster-type-features">
              <li>Kind, Minikube, K3s, EKS, GKE, AKS</li>
              <li>Instant connection via kubeconfig</li>
              <li>Test connection before saving</li>
              <li>Full monitoring &amp; diagnostics</li>
            </ul>
            <button className="button button-success cluster-type-btn">
              Import Existing Cluster
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCluster;
